module.exports = __webpack_public_path__ + "static/media/amazonpay.01808671.png";